module.exports = __webpack_public_path__ + "static/media/air-hockey.247ed970.jpg";